import {Component, Input, OnInit} from '@angular/core';
import {UvIndexVorhersage} from "../../../../../../../model/vorhersagen/vorhersage-uv-index";

@Component({
  selector: 'app-uv-index-detail',
  templateUrl: './uv-index-detail.component.html',
  styleUrls: ['./uv-index-detail.component.css']
})
export class UvIndexDetailComponent{

  @Input() uv: UvIndexVorhersage;

}
